import Img from '@core/components/Img';
import Route from '@core/components/Route';
import { RoutePath } from '@core/types/route';
import { SxProps, Theme } from '@mui/material/styles';
import Grid2 from '@shared/components/Grid2';
import Paragraph from '@shared/components/Paragraph';
import { FC, memo } from 'react';

import { H2Gold } from '../../components/ColoredHeading';
import GenericLayout from '../../components/GenericLayout';
import NoPageImageSection from '../../components/NoPageImageSection';
import { COLOR } from '../../types/theme';
import { colorToCss } from '../../utils/theme';

const SX_IMG: SxProps<Theme> = {
  borderRadius: '0.25rem',
  marginY: '0.25rem',
  maxWidth: '300px',
  width: '100%',
};

const JuJutsu: FC = () => (
  <GenericLayout title='Ju-Jutsu'>
    <NoPageImageSection background={colorToCss(COLOR.Dark3)}>
      <Grid2 spacing='2rem'>
        <Grid2.Item>
          <H2Gold>Ju-Jutsu</H2Gold>

          <Paragraph margin='0'>
            Ju-Jutsu des Deutschen Ju-Jutsu Verband e.V. ist eine Kampfsportart die ursprünglich auf
            Judo, Karate und Aikido basierte. Die scheinbar besten Techniken wurden kombiniert, um
            ein universelles System zu schaffen, dass für die Selbstverteidigung aber auch für den
            Dienstgebrauch bei der Polizei geeignet ist.
          </Paragraph>
          <Paragraph>
            Im Laufe der Zeit wurde Ju-Jutsu ständig weiter verbessert und weitere Kampfsportarten
            wurden integriert, unter anderem kamen Elemente aus dem Arnis und dem Boxen hinzu.
          </Paragraph>
          <Paragraph>
            Ju-Jutsu ist ein System, dass auf Techniken basiert und das vor allem auf Würfe, Hebel,
            Schläge, Tritte und Kombinationen daraus setzt. Darüber hinaus gibt es Wettkämpfe,
            sowohl Zweikampf als auch Duo Demonstrationen.
          </Paragraph>
          <Paragraph>
            Im Ju-Jutsu existiert ein Prüfungsprogramm, welches sechs Schülergrade (weiß, gelb,
            orange, grün, blau, braun), zwei Lehrergrade (1. und 2. Dan), drei Meistergrade (3. - 5.
            Dan) und fünf Großmeistergrade (6. - 10. Dan) enthält. Die Grade bis zum 5. Dan können
            durch Prüfung erworben werden, die Großmeistergrade werden für besondere Verdienste
            verliehen.
          </Paragraph>

          <Paragraph margin={{ bottom: '0.75em', top: '1.5rem' }}>
            <Route href={RoutePath.FalkoZander}>Falko Zander</Route> war Vorstand und Lehrwart des
            Brandenburgischen Ju-Jutsu Verband e.V., Mitglied der Technischen Kommission des
            Deutschen Ju-Jutsu Verband e.V. und Abteilungsleiter mehrerer Vereine im Land
            Brandenburg. Er war Inhaber der Prüfer- und Kampfrichter-Lizenz, der Kursleiter-Lizenz
            für Frauen-Selbstverteidigung und der Fachübungsleiter C Lizenz für Ju-Jutsu des
            Deutschen Sportbundes. Er ist Inhaber des 3. Dan.
          </Paragraph>
        </Grid2.Item>
        <Grid2.Centered>
          <Img
            alt='Falko Zander, 3. Dan JJ, 2001'
            src='/img/img-falko-zander-jujutsu.jpg'
            sx={SX_IMG}
          />
          <Paragraph margin='0' variant='body2'>
            Falko Zander, 3. Dan JJ, 2001
          </Paragraph>
        </Grid2.Centered>
      </Grid2>
    </NoPageImageSection>
  </GenericLayout>
);

export default memo(JuJutsu);
